module.exports = __webpack_public_path__ + "static/img/Booked_appointment.3f2e17d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Booked_appointment.png
// module id = y6Qg
// module chunks = 7